import {
    Breakpoint,
    CSSInterpolation,
    Theme,
    useMediaQuery,
} from "@mui/material";

export const ifUpBreakpoint = (
    theme: Theme | undefined,
    breakpoint: Breakpoint,
) => !!theme && useMediaQuery(theme.breakpoints.up(breakpoint));

export const ifDownBreakpoint = (
    theme: Theme | undefined,
    breakpoint: Breakpoint,
) => !!theme && useMediaQuery(theme.breakpoints.down(breakpoint));

export const mediaQueryDownStyle = (
    theme: Theme | undefined,
    breakpoint: Breakpoint,
    styles: CSSInterpolation,
) =>
    !!theme
        ? {
              [theme.breakpoints.down(breakpoint)]: styles,
          }
        : {};
